import { ref, computed, watch, onMounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { useDPD, useValidationRules } from '~/composables';


export default {
  __name: 'ServiceFormDpdFields',
  props: {
  selectedCountry: {
    type: [String, Number],
    default: null,
  },
},
  emits: ['change', 'countries-loaded'],
  setup(__props, { expose, emit }) {

const props = __props;





const getFullAddressStringFromAddressObj = (addressObj) =>
  `${addressObj.city}, ${addressObj.postcode}, ${addressObj.street} ${addressObj.house_number}`;

const autocompleteRef = ref();
const searchedAddress = ref('');
const fullAddress = ref('');

const {
  getDpdCountries,
  dpdCountries,
  getDpdCities,
  dpdCities,
  isDpdCitiesLoading,
} = useDPD();

const suggestions = ref([]);
const isLoading = computed(() => isDpdCitiesLoading.value);

const { addressRules, errorMessages } = useValidationRules();

const v$ = useVuelidate(
  {
    searchedAddress: addressRules(
      suggestions,
      fullAddress,
      getFullAddressStringFromAddressObj,
    ),
  },
  { searchedAddress },
);

const isAddressSelectDisabled = computed(() => {
  return !props.selectedCountry || suggestions.value?.length === 0;
});

const handleAddressInput = (value) => {
  searchedAddress.value = value;
  v$.value.searchedAddress.$touch();
};

const searchAddress = (event) => {
  searchedAddress.value = event.query;

  if (!event.query) {
    suggestions.value = dpdCities.value;
    return;
  }

  const filteredSuggestions = dpdCities.value.filter((dpdAddress) => {
    const fullAddressString = getFullAddressStringFromAddressObj(dpdAddress);
    return fullAddressString
      .toLowerCase()
      .includes(event.query.toLowerCase().trim());
  });
  suggestions.value = filteredSuggestions;
};

const handleSelectAddress = (event) => {
  const selectedFullAddress = getFullAddressStringFromAddressObj(event.value);
  searchedAddress.value = selectedFullAddress;
  fullAddress.value = selectedFullAddress;

  emit('change', {
    fieldName: 'fullAddress',
    fieldValue: selectedFullAddress,
  });
};

const loadCitiesByCountry = async (countryName) => {
  if (!countryName) return;

  const selectedCountry = dpdCountries.value.find(
    (country) => country.name === countryName,
  );
  if (!selectedCountry) return;

  await getDpdCities(selectedCountry.id);
  suggestions.value = dpdCities.value;
};

onMounted(async () => {
  if (dpdCountries.value.length === 0) {
    await getDpdCountries();
  }
  emit('countries-loaded', dpdCountries.value);
});

watch(
  () => props.selectedCountry,
  (newCountry) => {
    if (newCountry) {
      loadCitiesByCountry(newCountry);
    }

    searchedAddress.value = '';
    fullAddress.value = '';
    suggestions.value = [];
    v$.value.$reset();
  },
);

const resetValidation = () => {
  v$.value.$reset();
};

expose({ resetValidation });

return { __sfc: true,props, emit, getFullAddressStringFromAddressObj, autocompleteRef, searchedAddress, fullAddress, getDpdCountries, dpdCountries, getDpdCities, dpdCities, isDpdCitiesLoading, suggestions, isLoading, addressRules, errorMessages, v$, isAddressSelectDisabled, handleAddressInput, searchAddress, handleSelectAddress, loadCitiesByCountry, resetValidation }
}

}